/// <reference path="../typings/index.d.ts" />
namespace App {
    export class BloquearDebug {
        public bloquearDepuracao(habilitarDebug: boolean = false) {
            if (habilitarDebug) {
                return;
            }
            document.addEventListener('contextmenu', e => e.preventDefault());
            $(document).keydown(function(e) {
                if (e.keyCode == 123) {
                    console.log('You cannot inspect Element');
                    return false;
                }
                if (e.ctrlKey && e.shiftKey && e.keyCode == 'I'.charCodeAt(0)) {
                    console.log('You cannot inspect Element');
                    return false;
                }
                if (e.ctrlKey && e.shiftKey && e.keyCode == 'C'.charCodeAt(0)) {
                    console.log('You cannot inspect Element');
                    return false;
                }
                if (e.ctrlKey && e.shiftKey && e.keyCode == 'J'.charCodeAt(0)) {
                    console.log('You cannot inspect Element');
                    return false;
                }
                if (e.ctrlKey && e.keyCode == 'U'.charCodeAt(0)) {
                    console.log('You cannot inspect Element');
                    return false;
                }
            });

        }
    }
}
